/* eslint-disable */
// Additional / repositioned translations (Civic Social Network).
// Deep-merged (2 levels) over base translations in i18n.js.

export const translationsExtra = {
    it: {
        nav: { sostieni: "Sostieni" },
        community: {
            eyebrow: "La community",
            headline_a: "Migliaia di cittadini,",
            headline_b: "un'unica rete",
            caption: "Persone reali che ogni giorno rendono le loro città più giuste.",
        },
        hero: {
            eyebrow: "Il primo Civic Social Network",
            subtitle:
                "Non likes, ma cittadinanza attiva. Segnala, documenta e risolvi i problemi della tua città — geolocalizzato, verificato dall'IA e giuridicamente solido.",
        },
        problem: {
            eyebrow: "Il problema",
            headline_a: "I social di oggi non sono fatti per la tua",
            headline_b: "città",
            body: "Buche, degrado, abusi, pericoli: li vediamo ogni giorno. Ma sui social si perdono tra intrattenimento e rumore — senza contesto, senza tutela per chi segnala, senza mai diventare azione.",
            points: [
                { title: "Nessun contesto", text: "Una foto senza luogo, ora e categoria non serve a nessuno." },
                { title: "Nessuna tutela", text: "Chi denuncia rischia diffamazione o ritorsioni. Da solo." },
                { title: "Nessun impatto", text: "Like e commenti non riparano una strada né fermano un abuso." },
            ],
        },
        comparison: {
            eyebrow: "Il confronto",
            headline_a: "Non un altro social. Un",
            headline_b: "atto civico",
            colA: "Social tradizionali",
            colB: "Sentinel",
            rows: [
                { label: "Scopo", a: "Intrattenimento, vanità", b: "Impatto civico reale" },
                { label: "Contenuti", a: "Casuali", b: "Geolocalizzati, datati, categorizzati" },
                { label: "IA", a: "Massimizza l'engagement", b: "Protegge i minori, modera, verifica" },
                { label: "Reputazione", a: "Follower comprabili", b: "Merito civico non trasferibile" },
                { label: "Prove legali", a: "Nessuna", b: "PDF forense con hash e timestamp" },
                { label: "Compliance", a: "Aggiunta dopo", b: "DSA/GDPR by design" },
                { label: "Minori", a: "Filtri manuali", b: "Vision AI + blur automatico" },
                { label: "I tuoi dati", a: "Dell'azienda", b: "Tuoi (export & cancellazione)" },
            ],
        },
        roadmap: {
            eyebrow: "Roadmap",
            headline_a: "Costruita alla luce del",
            headline_b: "sole",
            phases: [
                { tag: "Live · MVP", title: "Disponibile ora", items: ["Segnalazioni geolocalizzate", "Moderazione IA + Vision minori", "Reputazione Climax", "Ricorsi & transparency report", "Marketplace legale", "7 lingue · GDPR"] },
                { tag: "Prossimi mesi", title: "In arrivo", items: ["Mappa civica interattiva", "Pagamenti reali (crediti & ads)", "Trusted flaggers regionali", "API per comuni e ong", "App iOS & Android"] },
                { tag: "12 mesi", title: "La visione", items: ["Partnership con enti locali", "Certificazione forense dei report", "Espansione 25+ lingue", "Programma \"Sentinel for Municipalities\""] },
            ],
        },
        support: {
            eyebrow: "Sostieni il progetto",
            headline_a: "La tecnologia dalla parte dei",
            headline_b: "cittadini",
            body: "I social tradizionali guadagnano dalla polarizzazione. Noi guadagniamo quando la tua città migliora. Per restare indipendenti dai big tech, abbiamo bisogno di te.",
            allocationTitle: "Dove vanno i fondi",
            allocation: [
                { pct: "40%", label: "Sviluppo (mappa, app store, API)" },
                { pct: "25%", label: "Infrastruttura IA" },
                { pct: "20%", label: "Compliance legale" },
                { pct: "10%", label: "Partnership territoriali" },
                { pct: "5%", label: "Educazione civica" },
            ],
            tiersTitle: "Ricompense",
            tiers: [
                { price: "15€", name: "Cittadino Fondatore", desc: "Badge esclusivo + 100 crediti civici" },
                { price: "45€", name: "Sentinella", desc: "1 anno Premium + boost tier Climax" },
                { price: "90€", name: "Testimone", desc: "1 anno Plus (PDF illimitati) + beta" },
                { price: "250€", name: "Alleato Civico", desc: "Menzione in-app + workshop online" },
            ],
            cta: "Sostieni su Kickstarter",
        },
        features: {
            eyebrow: "Funzionalità",
            count: "Otto pilastri",
            items: [
                { title: "IA protettiva per i minori", text: "Vision AI rileva i volti dei minori e applica il blur automatico prima della pubblicazione." },
                { title: "Prove legalmente valide", text: "Report PDF forense con hash, coordinate e timestamp. Catena di custodia inclusa." },
                { title: "Moderazione & Fake detection", text: "L'IA classifica gravità e contesto e blocca i contenuti generati artificialmente." },
                { title: "Reputazione Climax", text: "Un percorso meritocratico a livelli: punti civici, tier, streak. Mai pay-to-win." },
                { title: "Marketplace legale", text: "Avvocati verificati specializzati, contattabili direttamente dalla segnalazione." },
                { title: "Compliance DSA/GDPR", text: "Ricorsi tracciati, blocco bilaterale, transparency report, export & delete-me." },
                { title: "Economia civica equa", text: "Civic Points e Credits guadagnati con l'utilità reale. Nessuna monetizzazione predatoria." },
                { title: "Multilingua & scalabile", text: "Sette lingue, pronto per una scala globale. La cittadinanza non ha confini." },
            ],
        },
        faq: {
            items: [
                { q: "I miei dati sono privati?", a: "Sì. Privacy by design, anonimato garantito, export e cancellazione GDPR in ogni momento." },
                { q: "Come proteggete i minori?", a: "La Vision AI rileva i volti dei minori e applica il blur automatico prima della pubblicazione. Protezione di default, non su richiesta." },
                { q: "Le prove sono valide legalmente?", a: "Con il piano Plus generi un PDF forense con hash, coordinate GPS, timestamp e catena di custodia, utilizzabile con avvocati e amministrazioni." },
                { q: "Come funziona la reputazione?", a: "Il sistema Climax premia la cittadinanza attiva con punti e livelli meritocratici. Si può salire e retrocedere: non è pay-to-win." },
                { q: "Come vi finanziate?", a: "Ads etici self-service, crediti civici e marketplace legale. Nessun algoritmo tossico, nessun dark pattern." },
                { q: "Siete conformi a DSA e GDPR?", a: "Compliance by design: ricorsi trasparenti, blocco bilaterale, transparency report pubblico e workflow di legal notice." },
            ],
        },
    },

    en: {
        nav: { sostieni: "Support" },
        community: {
            eyebrow: "The community",
            headline_a: "Thousands of citizens,",
            headline_b: "one network",
            caption: "Real people who make their cities fairer, every single day.",
        },
        hero: {
            eyebrow: "The first Civic Social Network",
            subtitle:
                "Not likes, but active citizenship. Report, document and solve your city's problems — geolocated, AI-verified and legally solid.",
        },
        problem: {
            eyebrow: "The problem",
            headline_a: "Today's socials aren't built for your",
            headline_b: "city",
            body: "Potholes, decay, abuse, hazards: we see them every day. But on social media they get lost between entertainment and noise — no context, no protection for whistleblowers, never turning into action.",
            points: [
                { title: "No context", text: "A photo without place, time and category helps no one." },
                { title: "No protection", text: "Whoever reports risks defamation or retaliation. Alone." },
                { title: "No impact", text: "Likes and comments won't fix a road or stop an abuse." },
            ],
        },
        comparison: {
            eyebrow: "The comparison",
            headline_a: "Not another social. A",
            headline_b: "civic act",
            colA: "Traditional socials",
            colB: "Sentinel",
            rows: [
                { label: "Purpose", a: "Entertainment, vanity", b: "Real civic impact" },
                { label: "Content", a: "Random", b: "Geolocated, timestamped, categorised" },
                { label: "AI", a: "Maximises engagement", b: "Protects minors, moderates, verifies" },
                { label: "Reputation", a: "Buyable followers", b: "Non-transferable civic merit" },
                { label: "Legal proof", a: "None", b: "Forensic PDF with hash & timestamp" },
                { label: "Compliance", a: "Bolted on later", b: "DSA/GDPR by design" },
                { label: "Minors", a: "Manual filters", b: "Vision AI + automatic blur" },
                { label: "Your data", a: "The company's", b: "Yours (GDPR export & delete)" },
            ],
        },
        roadmap: {
            eyebrow: "Roadmap",
            headline_a: "Built in broad",
            headline_b: "daylight",
            phases: [
                { tag: "Live · MVP", title: "Available now", items: ["Geolocated reports", "AI moderation + minor Vision", "Climax reputation", "Appeals & transparency report", "Legal marketplace", "7 languages · GDPR"] },
                { tag: "Coming months", title: "Coming up", items: ["Interactive civic map", "Real payments (credits & ads)", "Regional trusted flaggers", "API for municipalities & NGOs", "iOS & Android apps"] },
                { tag: "12 months", title: "The vision", items: ["Partnerships with local bodies", "Forensic report certification", "25+ language expansion", "\"Sentinel for Municipalities\" program"] },
            ],
        },
        support: {
            eyebrow: "Support the project",
            headline_a: "Technology on the side of",
            headline_b: "citizens",
            body: "Traditional socials profit from polarisation. We profit when your city improves. To stay independent from big tech, we need you.",
            allocationTitle: "Where the funds go",
            allocation: [
                { pct: "40%", label: "Development (map, app store, API)" },
                { pct: "25%", label: "AI infrastructure" },
                { pct: "20%", label: "Legal compliance" },
                { pct: "10%", label: "Local partnerships" },
                { pct: "5%", label: "Civic education" },
            ],
            tiersTitle: "Rewards",
            tiers: [
                { price: "€15", name: "Founding Citizen", desc: "Exclusive badge + 100 civic credits" },
                { price: "€45", name: "Sentinel", desc: "1 year Premium + Climax tier boost" },
                { price: "€90", name: "Witness", desc: "1 year Plus (unlimited PDFs) + beta" },
                { price: "€250", name: "Civic Ally", desc: "In-app mention + online workshop" },
            ],
            cta: "Back us on Kickstarter",
        },
        features: {
            eyebrow: "Features",
            count: "Eight pillars",
            items: [
                { title: "Protective AI for minors", text: "Vision AI detects minors' faces and applies automatic blur before publishing." },
                { title: "Legally valid proof", text: "Forensic PDF report with hash, coordinates and timestamp. Chain of custody included." },
                { title: "Moderation & Fake detection", text: "The AI classifies severity and context and blocks AI-generated content." },
                { title: "Climax reputation", text: "A meritocratic level path: civic points, tiers, streaks. Never pay-to-win." },
                { title: "Legal marketplace", text: "Verified specialist lawyers, reachable directly from the report." },
                { title: "DSA/GDPR compliance", text: "Tracked appeals, bilateral block, transparency report, export & delete-me." },
                { title: "Fair civic economy", text: "Civic Points and Credits earned through real usefulness. No predatory monetisation." },
                { title: "Multilingual & scalable", text: "Seven languages, ready for global scale. Citizenship has no borders." },
            ],
        },
        faq: {
            items: [
                { q: "Is my data private?", a: "Yes. Privacy by design, guaranteed anonymity, GDPR export and deletion at any time." },
                { q: "How do you protect minors?", a: "Vision AI detects minors' faces and applies automatic blur before publishing. Protection by default, not on request." },
                { q: "Is the proof legally valid?", a: "With the Plus plan you generate a forensic PDF with hash, GPS coordinates, timestamp and chain of custody, usable with lawyers and administrations." },
                { q: "How does reputation work?", a: "The Climax system rewards active citizenship with meritocratic points and levels. You can rise and fall: it's not pay-to-win." },
                { q: "How are you funded?", a: "Ethical self-service ads, civic credits and a legal marketplace. No toxic algorithm, no dark patterns." },
                { q: "Are you DSA and GDPR compliant?", a: "Compliance by design: transparent appeals, bilateral block, public transparency report and legal notice workflow." },
            ],
        },
    },

    es: {
        nav: { sostieni: "Apoya" },
        community: {
            eyebrow: "La comunidad",
            headline_a: "Miles de ciudadanos,",
            headline_b: "una sola red",
            caption: "Personas reales que cada día hacen sus ciudades más justas.",
        },
        hero: {
            eyebrow: "La primera Red Social Cívica",
            subtitle:
                "No likes, sino ciudadanía activa. Denuncia, documenta y resuelve los problemas de tu ciudad — geolocalizado, verificado por IA y jurídicamente sólido.",
        },
        problem: {
            eyebrow: "El problema",
            headline_a: "Las redes de hoy no están hechas para tu",
            headline_b: "ciudad",
            body: "Baches, degrado, abusos, peligros: los vemos cada día. Pero en las redes se pierden entre entretenimiento y ruido — sin contexto, sin tutela para quien denuncia, sin convertirse nunca en acción.",
            points: [
                { title: "Sin contexto", text: "Una foto sin lugar, hora y categoría no sirve a nadie." },
                { title: "Sin protección", text: "Quien denuncia arriesga difamación o represalias. Solo." },
                { title: "Sin impacto", text: "Los likes no reparan una calle ni detienen un abuso." },
            ],
        },
        comparison: {
            eyebrow: "La comparación",
            headline_a: "No otra red social. Un",
            headline_b: "acto cívico",
            colA: "Redes tradicionales",
            colB: "Sentinel",
            rows: [
                { label: "Propósito", a: "Entretenimiento, vanidad", b: "Impacto cívico real" },
                { label: "Contenidos", a: "Aleatorios", b: "Geolocalizados, fechados, categorizados" },
                { label: "IA", a: "Maximiza el engagement", b: "Protege a los menores, modera, verifica" },
                { label: "Reputación", a: "Seguidores comprables", b: "Mérito cívico no transferible" },
                { label: "Pruebas legales", a: "Ninguna", b: "PDF forense con hash y timestamp" },
                { label: "Compliance", a: "Añadida después", b: "DSA/GDPR by design" },
                { label: "Menores", a: "Filtros manuales", b: "Vision AI + blur automático" },
                { label: "Tus datos", a: "De la empresa", b: "Tuyos (exportar y borrar)" },
            ],
        },
        roadmap: {
            eyebrow: "Roadmap",
            headline_a: "Construida a plena",
            headline_b: "luz",
            phases: [
                { tag: "Live · MVP", title: "Disponible ahora", items: ["Denuncias geolocalizadas", "Moderación IA + Vision menores", "Reputación Climax", "Recursos & transparency report", "Marketplace legal", "7 idiomas · GDPR"] },
                { tag: "Próximos meses", title: "Próximamente", items: ["Mapa cívico interactivo", "Pagos reales (créditos & ads)", "Trusted flaggers regionales", "API para ayuntamientos y ong", "Apps iOS & Android"] },
                { tag: "12 meses", title: "La visión", items: ["Alianzas con entes locales", "Certificación forense de informes", "Expansión 25+ idiomas", "Programa \"Sentinel for Municipalities\""] },
            ],
        },
        support: {
            eyebrow: "Apoya el proyecto",
            headline_a: "La tecnología del lado de los",
            headline_b: "ciudadanos",
            body: "Las redes tradicionales ganan con la polarización. Nosotros ganamos cuando tu ciudad mejora. Para seguir independientes de las big tech, te necesitamos.",
            allocationTitle: "Adónde van los fondos",
            allocation: [
                { pct: "40%", label: "Desarrollo (mapa, app store, API)" },
                { pct: "25%", label: "Infraestructura IA" },
                { pct: "20%", label: "Compliance legal" },
                { pct: "10%", label: "Alianzas territoriales" },
                { pct: "5%", label: "Educación cívica" },
            ],
            tiersTitle: "Recompensas",
            tiers: [
                { price: "15€", name: "Ciudadano Fundador", desc: "Insignia exclusiva + 100 créditos cívicos" },
                { price: "45€", name: "Centinela", desc: "1 año Premium + boost tier Climax" },
                { price: "90€", name: "Testigo", desc: "1 año Plus (PDF ilimitados) + beta" },
                { price: "250€", name: "Aliado Cívico", desc: "Mención in-app + workshop online" },
            ],
            cta: "Apóyanos en Kickstarter",
        },
        features: {
            eyebrow: "Funcionalidades",
            count: "Ocho pilares",
            items: [
                { title: "IA protectora de menores", text: "Vision AI detecta los rostros de menores y aplica blur automático antes de publicar." },
                { title: "Pruebas legalmente válidas", text: "Informe PDF forense con hash, coordenadas y timestamp. Cadena de custodia incluida." },
                { title: "Moderación & Fake detection", text: "La IA clasifica gravedad y contexto y bloquea contenidos generados artificialmente." },
                { title: "Reputación Climax", text: "Un camino meritocrático por niveles: puntos cívicos, tiers, streaks. Nunca pay-to-win." },
                { title: "Marketplace legal", text: "Abogados verificados especializados, contactables directamente desde la denuncia." },
                { title: "Compliance DSA/GDPR", text: "Recursos trazados, bloqueo bilateral, transparency report, exportar y borrar." },
                { title: "Economía cívica justa", text: "Civic Points y Credits ganados con utilidad real. Sin monetización predatoria." },
                { title: "Multilingüe & escalable", text: "Siete idiomas, listo para escala global. La ciudadanía no tiene fronteras." },
            ],
        },
        faq: {
            items: [
                { q: "¿Mis datos son privados?", a: "Sí. Privacy by design, anonimato garantizado, exportación y borrado GDPR en cualquier momento." },
                { q: "¿Cómo protegéis a los menores?", a: "Vision AI detecta los rostros de menores y aplica blur automático antes de publicar. Protección por defecto, no bajo petición." },
                { q: "¿Las pruebas son válidas legalmente?", a: "Con el plan Plus generas un PDF forense con hash, coordenadas GPS, timestamp y cadena de custodia, utilizable con abogados y administraciones." },
                { q: "¿Cómo funciona la reputación?", a: "El sistema Climax premia la ciudadanía activa con puntos y niveles meritocráticos. Se puede subir y bajar: no es pay-to-win." },
                { q: "¿Cómo os financiáis?", a: "Ads éticos self-service, créditos cívicos y marketplace legal. Sin algoritmo tóxico, sin dark patterns." },
                { q: "¿Cumplís con DSA y GDPR?", a: "Compliance by design: recursos transparentes, bloqueo bilateral, transparency report público y workflow de legal notice." },
            ],
        },
    },

    fr: {
        nav: { sostieni: "Soutenir" },
        community: {
            eyebrow: "La communauté",
            headline_a: "Des milliers de citoyens,",
            headline_b: "un seul réseau",
            caption: "Des personnes réelles qui rendent leurs villes plus justes, chaque jour.",
        },
        hero: {
            eyebrow: "Le premier Réseau Social Civique",
            subtitle:
                "Pas des likes, mais une citoyenneté active. Signale, documente et résous les problèmes de ta ville — géolocalisé, vérifié par l'IA et juridiquement solide.",
        },
        problem: {
            eyebrow: "Le problème",
            headline_a: "Les réseaux d'aujourd'hui ne sont pas faits pour ta",
            headline_b: "ville",
            body: "Nids-de-poule, dégradations, abus, dangers : on les voit chaque jour. Mais sur les réseaux ils se perdent entre divertissement et bruit — sans contexte, sans protection pour qui signale, sans jamais devenir action.",
            points: [
                { title: "Aucun contexte", text: "Une photo sans lieu, heure et catégorie ne sert à personne." },
                { title: "Aucune protection", text: "Qui signale risque diffamation ou représailles. Seul." },
                { title: "Aucun impact", text: "Les likes ne réparent pas une route ni n'arrêtent un abus." },
            ],
        },
        comparison: {
            eyebrow: "La comparaison",
            headline_a: "Pas un réseau de plus. Un",
            headline_b: "acte civique",
            colA: "Réseaux traditionnels",
            colB: "Sentinel",
            rows: [
                { label: "But", a: "Divertissement, vanité", b: "Impact civique réel" },
                { label: "Contenus", a: "Aléatoires", b: "Géolocalisés, datés, catégorisés" },
                { label: "IA", a: "Maximise l'engagement", b: "Protège les mineurs, modère, vérifie" },
                { label: "Réputation", a: "Abonnés achetables", b: "Mérite civique non transférable" },
                { label: "Preuves légales", a: "Aucune", b: "PDF forensique avec hash & timestamp" },
                { label: "Conformité", a: "Ajoutée après", b: "DSA/RGPD by design" },
                { label: "Mineurs", a: "Filtres manuels", b: "Vision AI + flou automatique" },
                { label: "Tes données", a: "À l'entreprise", b: "À toi (export & suppression)" },
            ],
        },
        roadmap: {
            eyebrow: "Roadmap",
            headline_a: "Construite en pleine",
            headline_b: "lumière",
            phases: [
                { tag: "Live · MVP", title: "Disponible maintenant", items: ["Signalements géolocalisés", "Modération IA + Vision mineurs", "Réputation Climax", "Recours & transparency report", "Marketplace juridique", "7 langues · RGPD"] },
                { tag: "Prochains mois", title: "À venir", items: ["Carte civique interactive", "Paiements réels (crédits & ads)", "Trusted flaggers régionaux", "API pour communes et ONG", "Apps iOS & Android"] },
                { tag: "12 mois", title: "La vision", items: ["Partenariats avec les collectivités", "Certification forensique des rapports", "Expansion 25+ langues", "Programme \"Sentinel for Municipalities\""] },
            ],
        },
        support: {
            eyebrow: "Soutiens le projet",
            headline_a: "La technologie du côté des",
            headline_b: "citoyens",
            body: "Les réseaux traditionnels profitent de la polarisation. Nous profitons quand ta ville s'améliore. Pour rester indépendants des big tech, nous avons besoin de toi.",
            allocationTitle: "Où vont les fonds",
            allocation: [
                { pct: "40%", label: "Développement (carte, app store, API)" },
                { pct: "25%", label: "Infrastructure IA" },
                { pct: "20%", label: "Conformité juridique" },
                { pct: "10%", label: "Partenariats locaux" },
                { pct: "5%", label: "Éducation civique" },
            ],
            tiersTitle: "Récompenses",
            tiers: [
                { price: "15€", name: "Citoyen Fondateur", desc: "Badge exclusif + 100 crédits civiques" },
                { price: "45€", name: "Sentinelle", desc: "1 an Premium + boost tier Climax" },
                { price: "90€", name: "Témoin", desc: "1 an Plus (PDF illimités) + bêta" },
                { price: "250€", name: "Allié Civique", desc: "Mention in-app + atelier en ligne" },
            ],
            cta: "Soutiens-nous sur Kickstarter",
        },
        features: {
            eyebrow: "Fonctionnalités",
            count: "Huit piliers",
            items: [
                { title: "IA protectrice des mineurs", text: "Vision AI détecte les visages des mineurs et applique un flou automatique avant publication." },
                { title: "Preuves juridiquement valides", text: "Rapport PDF forensique avec hash, coordonnées et timestamp. Chaîne de custody incluse." },
                { title: "Modération & Fake detection", text: "L'IA classe la gravité et le contexte et bloque les contenus générés par IA." },
                { title: "Réputation Climax", text: "Un parcours méritocratique par niveaux : points civiques, tiers, streaks. Jamais pay-to-win." },
                { title: "Marketplace juridique", text: "Avocats vérifiés spécialisés, joignables directement depuis le signalement." },
                { title: "Conformité DSA/RGPD", text: "Recours tracés, blocage bilatéral, transparency report, export & suppression." },
                { title: "Économie civique équitable", text: "Civic Points et Credits gagnés par l'utilité réelle. Pas de monétisation prédatrice." },
                { title: "Multilingue & scalable", text: "Sept langues, prêt pour l'échelle mondiale. La citoyenneté n'a pas de frontières." },
            ],
        },
        faq: {
            items: [
                { q: "Mes données sont-elles privées ?", a: "Oui. Privacy by design, anonymat garanti, export et suppression RGPD à tout moment." },
                { q: "Comment protégez-vous les mineurs ?", a: "Vision AI détecte les visages des mineurs et applique un flou automatique avant publication. Protection par défaut, pas sur demande." },
                { q: "Les preuves sont-elles valides ?", a: "Avec le plan Plus, tu génères un PDF forensique avec hash, coordonnées GPS, timestamp et chaîne de custody, utilisable avec avocats et administrations." },
                { q: "Comment fonctionne la réputation ?", a: "Le système Climax récompense la citoyenneté active avec des points et niveaux méritocratiques. On peut monter et descendre : ce n'est pas pay-to-win." },
                { q: "Comment êtes-vous financés ?", a: "Publicités éthiques self-service, crédits civiques et marketplace juridique. Pas d'algorithme toxique, pas de dark patterns." },
                { q: "Êtes-vous conformes DSA et RGPD ?", a: "Conformité by design : recours transparents, blocage bilatéral, transparency report public et workflow de legal notice." },
            ],
        },
    },

    de: {
        nav: { sostieni: "Unterstützen" },
        community: {
            eyebrow: "Die Community",
            headline_a: "Tausende Bürger,",
            headline_b: "ein Netzwerk",
            caption: "Echte Menschen, die ihre Städte jeden Tag gerechter machen.",
        },
        hero: {
            eyebrow: "Das erste Civic Social Network",
            subtitle:
                "Keine Likes, sondern aktive Bürgerschaft. Melde, dokumentiere und löse die Probleme deiner Stadt — geolokalisiert, KI-verifiziert und rechtlich belastbar.",
        },
        problem: {
            eyebrow: "Das Problem",
            headline_a: "Heutige soziale Netze sind nicht für deine",
            headline_b: "Stadt gemacht",
            body: "Schlaglöcher, Verfall, Missbrauch, Gefahren: wir sehen sie täglich. Doch in den sozialen Netzen gehen sie zwischen Unterhaltung und Lärm verloren — ohne Kontext, ohne Schutz für Meldende, ohne je zur Aktion zu werden.",
            points: [
                { title: "Kein Kontext", text: "Ein Foto ohne Ort, Zeit und Kategorie nützt niemandem." },
                { title: "Kein Schutz", text: "Wer meldet, riskiert Verleumdung oder Vergeltung. Allein." },
                { title: "Keine Wirkung", text: "Likes reparieren keine Straße und stoppen keinen Missbrauch." },
            ],
        },
        comparison: {
            eyebrow: "Der Vergleich",
            headline_a: "Kein weiteres Netzwerk. Ein",
            headline_b: "Bürgerakt",
            colA: "Traditionelle Netze",
            colB: "Sentinel",
            rows: [
                { label: "Zweck", a: "Unterhaltung, Eitelkeit", b: "Echte zivile Wirkung" },
                { label: "Inhalte", a: "Zufällig", b: "Geolokalisiert, datiert, kategorisiert" },
                { label: "KI", a: "Maximiert Engagement", b: "Schützt Minderjährige, moderiert, prüft" },
                { label: "Reputation", a: "Kaufbare Follower", b: "Nicht übertragbares Bürgerverdienst" },
                { label: "Rechtsbeweis", a: "Keiner", b: "Forensisches PDF mit Hash & Timestamp" },
                { label: "Compliance", a: "Nachträglich", b: "DSA/DSGVO by design" },
                { label: "Minderjährige", a: "Manuelle Filter", b: "Vision AI + automatischer Blur" },
                { label: "Deine Daten", a: "Dem Unternehmen", b: "Dir (Export & Löschung)" },
            ],
        },
        roadmap: {
            eyebrow: "Roadmap",
            headline_a: "Gebaut im hellen",
            headline_b: "Tageslicht",
            phases: [
                { tag: "Live · MVP", title: "Jetzt verfügbar", items: ["Geolokalisierte Meldungen", "KI-Moderation + Vision Minderjährige", "Climax-Reputation", "Einsprüche & Transparency Report", "Rechts-Marktplatz", "7 Sprachen · DSGVO"] },
                { tag: "Nächste Monate", title: "In Kürze", items: ["Interaktive Bürgerkarte", "Echte Zahlungen (Credits & Ads)", "Regionale Trusted Flaggers", "API für Gemeinden & NGOs", "iOS & Android Apps"] },
                { tag: "12 Monate", title: "Die Vision", items: ["Partnerschaften mit Kommunen", "Forensische Zertifizierung der Reports", "Ausbau 25+ Sprachen", "Programm \"Sentinel for Municipalities\""] },
            ],
        },
        support: {
            eyebrow: "Unterstütze das Projekt",
            headline_a: "Technologie auf der Seite der",
            headline_b: "Bürger",
            body: "Traditionelle Netze profitieren von Polarisierung. Wir profitieren, wenn deine Stadt besser wird. Um unabhängig von Big Tech zu bleiben, brauchen wir dich.",
            allocationTitle: "Wohin die Mittel gehen",
            allocation: [
                { pct: "40%", label: "Entwicklung (Karte, App Store, API)" },
                { pct: "25%", label: "KI-Infrastruktur" },
                { pct: "20%", label: "Rechtliche Compliance" },
                { pct: "10%", label: "Lokale Partnerschaften" },
                { pct: "5%", label: "Zivilbildung" },
            ],
            tiersTitle: "Belohnungen",
            tiers: [
                { price: "15€", name: "Gründungsbürger", desc: "Exklusives Badge + 100 Bürger-Credits" },
                { price: "45€", name: "Schildwache", desc: "1 Jahr Premium + Climax-Tier-Boost" },
                { price: "90€", name: "Zeuge", desc: "1 Jahr Plus (unbegrenzte PDFs) + Beta" },
                { price: "250€", name: "Ziviler Verbündeter", desc: "In-App-Erwähnung + Online-Workshop" },
            ],
            cta: "Unterstütze uns auf Kickstarter",
        },
        features: {
            eyebrow: "Funktionen",
            count: "Acht Säulen",
            items: [
                { title: "Schützende KI für Minderjährige", text: "Vision AI erkennt Gesichter von Minderjährigen und wendet vor der Veröffentlichung automatischen Blur an." },
                { title: "Rechtlich gültige Beweise", text: "Forensischer PDF-Report mit Hash, Koordinaten und Timestamp. Chain of Custody inklusive." },
                { title: "Moderation & Fake-Erkennung", text: "Die KI bewertet Schwere und Kontext und blockiert KI-generierte Inhalte." },
                { title: "Climax-Reputation", text: "Ein meritokratischer Level-Pfad: Bürgerpunkte, Tiers, Streaks. Nie Pay-to-Win." },
                { title: "Rechts-Marktplatz", text: "Verifizierte Fachanwälte, direkt aus der Meldung erreichbar." },
                { title: "DSA/DSGVO-Compliance", text: "Nachverfolgte Einsprüche, bilaterale Sperre, Transparency Report, Export & Löschung." },
                { title: "Faire Bürger-Ökonomie", text: "Civic Points und Credits durch echten Nutzen verdient. Keine räuberische Monetarisierung." },
                { title: "Mehrsprachig & skalierbar", text: "Sieben Sprachen, bereit für globale Skalierung. Bürgerschaft kennt keine Grenzen." },
            ],
        },
        faq: {
            items: [
                { q: "Sind meine Daten privat?", a: "Ja. Privacy by Design, garantierte Anonymität, DSGVO-Export und -Löschung jederzeit." },
                { q: "Wie schützt ihr Minderjährige?", a: "Vision AI erkennt Gesichter von Minderjährigen und wendet vor der Veröffentlichung automatischen Blur an. Schutz standardmäßig, nicht auf Anfrage." },
                { q: "Sind die Beweise rechtlich gültig?", a: "Mit dem Plus-Plan erzeugst du ein forensisches PDF mit Hash, GPS-Koordinaten, Timestamp und Chain of Custody, nutzbar mit Anwälten und Behörden." },
                { q: "Wie funktioniert die Reputation?", a: "Das Climax-System belohnt aktive Bürgerschaft mit meritokratischen Punkten und Leveln. Man kann auf- und absteigen: kein Pay-to-Win." },
                { q: "Wie finanziert ihr euch?", a: "Ethische Self-Service-Ads, Bürger-Credits und Rechts-Marktplatz. Kein toxischer Algorithmus, keine Dark Patterns." },
                { q: "Seid ihr DSA- und DSGVO-konform?", a: "Compliance by Design: transparente Einsprüche, bilaterale Sperre, öffentlicher Transparency Report und Legal-Notice-Workflow." },
            ],
        },
    },
};
